<template lang="pug">
.og--generator--overlay(v-if="visibleSearchForm" @click.self="closeSearchForm()")
  .og--generator-card-content-games-editor
    .og--generator-card-content-games-editor-selector.bodoan-selector(id='game-selector')
      .og--generator-card-content-games-editor-selector-wrapper
        .og--generator-card-content-games-editor-selector-search.bodoan-search
          select.form-control.condition(v-model='filterType', @change='onSearch')
            option(value='mygame' v-if="userId") マイボードゲームから
            option(value='played' v-if="userId") 経験ありのみ
            option(value='favorite' v-if="userId") お気に入りのみ
            option(value='have' v-if="userId") 持ってるのみ
            option(value='all') 全てのデータベースから
          .input-group.freeword
            input(
              type='text'
              name='game[name]'
              class='form-control'
              v-model='freeword'
              placeholder='例: カタン'
              v-on:keyup.enter.exact="onSearch"
            )
            .input-group-addon.btn.btn-primary(@click='onSearch') <i class="fa fa-search"></i>
          .btn.btn-default.btn-close(@click='closeSearchForm()') <i class="fa fa-close"></i>
        .og--generator-card-content-games-editor-selector-result.bodoan-result
          .og--generator-card-content-games-editor-selector-result-item(v-for="answeredGame in selectedPoll.answeredGames")
            .og--generator-card-content-games-editor-selector-result-item-image
              img(:src="answeredGame.public_image_path" :alt="answeredGame.name")
            .og--generator-card-content-games-editor-selector-result-item-title {{answeredGame.name}}
            .og--generator-card-content-games-editor-selector-result-item-action
              .btn.btn-default.btn-sm(@click='unselectGame(answeredGame)' v-if='isSelected(answeredGame)') 選択を外す

          .og--generator-card-content-games-editor-selector-result-item(v-for="game in games" :class="isSelected(game) ? 'hidden' : ''")
            .og--generator-card-content-games-editor-selector-result-item-image
              img(:src="game.public_image_path" :alt="game.name")
            .og--generator-card-content-games-editor-selector-result-item-title {{game.name}}
            .og--generator-card-content-games-editor-selector-result-item-action
              .btn.btn-primary.btn-sm(@click='selectGame(game)' v-if='canSelect(game)') 選択する
              .btn.btn-default.btn-sm(@click='unselectGame(game)' v-if='isSelected(game)') 選択を外す
          infinite-loading(spinner="waveDots" @infinite="infiniteHandler" :key="infiniteId")
            span(slot="no-results")
              div(v-if="games.length == 0")
                p
                  | 申し訳ございません。<br>
                  | 該当するボードゲームが登録されていませんでした。<br>
                  | 大変お手数ではございますが、未登録のボードゲームの登録にご協力ください。<br>
                p
                  a(v-bind:href="'/mypage/newgame'" v-bind:rel="'noopener nofollow'" v-bind:target="'_blank'")
                    | ボードゲーム追加申請フォーム
            span(slot="no-more")

</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';

export default {
  components: { InfiniteLoading },
  props: {
    userId: {
      type: String,
      default: null,
    },
    defaultFilterType: {
      type: String,
      default: null,
    },
    selectedPollId: {
      type: Number,
      default: null,
    },
    polls: {
      type: Array,
      default: () => ([]),
    },
    games: {
      type: Array,
      default: () => ([]),
    },
    infiniteId: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      filterType: this.defaultFilterType,
      freeword: '',
      searching: false,
    };
  },
  computed: {
    selectedPoll: function() {
      return this.polls.find(poll => poll.id == this.selectedPollId);
    },
    visibleSearchForm: function() {
      return this.selectedPollId;
    },
  },
  methods: {
    selectGame: function(game) {
      if (this.canSelect(game)) {
        this.$emit('add-game', game);
      }
    },
    unselectGame: function(game) {
      if (this.isSelected(game)) {
        this.$emit('remove-game', game);
      }
    },
    isSelected: function(game) {
      const poll = this.polls.find(poll => poll.id == this.selectedPollId);
      return poll.answeredGames.map(answerGame => answerGame.id).indexOf(game.id) >= 0;
    },
    canSelect: function(game) {
      const poll = this.polls.find(poll => poll.id == this.selectedPollId);
      return !this.isSelected(game) && poll.answeredGames.length < 3;
    },
    onSearch: function() {
      let self = this;
      self.searching = true;
      this.$emit('search', this.filterType, this.freeword);
      self.searching = false;
    },
    infiniteHandler: function($state) {
      this.$emit('infinite-load', $state, this.filterType, this.freeword);
    },
    closeSearchForm: function() {
      this.$emit('close-search-form');
    },
  },
};
</script>

<style scoped lang="scss">
@import "app/assets/stylesheets/_mixin.scss";
@import "app/assets/stylesheets/_variable.scss";

.bodoan-search {
  margin-top: 78px;
}
.bodoan-selector {
  display: block;
}
.bodoan-result {
  @include responsive(xs) { height: calc(100vh - 78px - 150px); }
  @include responsive(sm) { height: calc(100vh - 34px - 110px); }
}
.og--generator--overlay {
    z-index: 1042;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
